import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

export default class extends Controller {
  static targets = ["container", "fade", "fadeTop"]

  connect() {
    reactor(this)
    this.boundCheck = this.check.bind(this)
    this.containerTarget.addEventListener("scroll", this.boundCheck)
    this.check()
  }

  disconnect() {
    this.containerTarget.removeEventListener("scroll", this.boundCheck)
  }

  morph() {
    this.check()
  }

  check() {
    const el = this.containerTarget

    const remaining = el.scrollHeight - el.scrollTop - el.clientHeight
    const fadeHeight = this.fadeTarget.offsetHeight
    this.fadeTarget.style.opacity = Math.min(1, remaining / fadeHeight)

    if (this.hasFadeTopTarget) {
      const scrolled = el.scrollTop
      const fadeTopHeight = this.fadeTopTarget.offsetHeight
      this.fadeTopTarget.style.opacity = Math.min(1, scrolled / fadeTopHeight)
    }
  }
}
